import ApiService from '@/services/api.service'


const LabService = {
    getPatientDemographicsToken(id) {
        return ApiService.getWithArray(`/ChangeHealthcareGateway/patientDemographics/${id}/token`)
    },

    checkUseLab() {
        return ApiService.get('/LabCredentials/useLab')
    }
}

export default LabService